import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Calendar, Clock } from "@air/next-icons";
import { formatDuration, parseAirDateToISO } from "@air/utilities";
import { format } from "__barrel_optimize__?names=format!=!date-fns";
import { memo } from "react";
import { useSelector } from "react-redux";
import { centralizedClipDurationSelector, centralizedClipRecordedAtSelector, centralizedDisplayTitleSelector } from "~/store/centralizedClip/selectors";
export const TranscriptVideoInfo = /*#__PURE__*/ memo(()=>{
    const clipTitle = useSelector(centralizedDisplayTitleSelector);
    const clipDuration = useSelector(centralizedClipDurationSelector);
    const createdDate = useSelector(centralizedClipRecordedAtSelector);
    const createdDateISO = parseAirDateToISO(createdDate);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-2.5 px-2 py-6",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "break-words text-16 font-semibold text-grey-12",
                children: clipTitle
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-2 text-12 text-grey-11",
                children: [
                    !!createdDate && /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ _jsx(Calendar, {
                                className: "size-4 text-grey-8"
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    format(createdDateISO, "MMM dd"),
                                    " at ",
                                    format(createdDateISO, "hh:mm a")
                                ]
                            })
                        ]
                    }),
                    !!clipDuration && /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ _jsx(Clock, {
                                className: "size-4 text-grey-8"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: formatDuration(clipDuration)
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
TranscriptVideoInfo.displayName = "TranscriptVideoInfo";
